import './paragoncatering/style';
import FormStructure from './paragoncatering/form_structure';

export default FormStructure;